import { render } from "./ProfileData.vue?vue&type=template&id=4581eb30&scoped=true"
import script from "./ProfileData.vue?vue&type=script&lang=js"
export * from "./ProfileData.vue?vue&type=script&lang=js"

import "./ProfileData.vue?vue&type=style&index=0&id=4581eb30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4581eb30"]])

export default __exports__